import FadeUp from "./FadeUp";
import {
    Users,
    Send,
    Gift,
    Coins,
    Youtube,
    Camera,
    BarChart3,
    FileText,
    Calendar,
} from "lucide-react";

const items = [
    { icon: Calendar, label: "Weekly strategy reviews with me" },
    { icon: Users, label: "Creator sourcing" },
    { icon: Send, label: "Outreach at volume" },
    { icon: Gift, label: "Product trials" },
    { icon: Coins, label: "Affiliate recruitment" },
    { icon: Youtube, label: "YouTube partnerships" },
    { icon: Camera, label: "UGC generation" },
    { icon: BarChart3, label: "Performance reporting" },
    { icon: FileText, label: "SOP documentation" },
];

export const WhatsIncluded = () => (
    <section
        id="whats-included"
        data-testid="whats-included-section"
        className="py-24 md:py-32 bg-white"
    >
        <div className="container-page">
            <div className="grid lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] gap-14 lg:gap-20 items-start">
                <div>
                    <FadeUp>
                        <p className="text-xs font-bold tracking-[0.22em] uppercase text-gray-500">
                            What's included
                        </p>
                    </FadeUp>
                    <FadeUp delay={0.05}>
                        <h2
                            data-testid="whats-included-heading"
                            className="mt-4 font-display font-extrabold text-3xl md:text-4xl lg:text-[44px] tracking-[-0.02em] leading-[1.55] md:leading-[1.55] lg:leading-[1.55] text-[#0A0A0A] text-balance"
                        >
                            You get me on strategy. My team runs the execution.
                        </h2>
                    </FadeUp>
                    <FadeUp delay={0.1}>
                        <p className="mt-6 text-[15.5px] md:text-base text-gray-600 leading-relaxed max-w-md">
                            Every engagement pairs direct access to me on strategy with a dedicated account manager who runs the day-to-day so nothing sits idle.
                        </p>
                    </FadeUp>
                    <FadeUp delay={0.15}>
                        <div className="mt-8 rounded-2xl border border-black/[0.08] bg-[#FAFAFA] p-5 md:p-6">
                            <p className="text-[11px] font-bold tracking-[0.2em] uppercase text-gray-500">
                                Who does what
                            </p>
                            <div className="mt-3 grid grid-cols-2 gap-4 text-[14px]">
                                <div>
                                    <div className="font-semibold text-[#0A0A0A]">Me</div>
                                    <div className="mt-1 text-gray-600 leading-[1.65]">
                                        Strategy, positioning, deal negotiation, senior review.
                                    </div>
                                </div>
                                <div>
                                    <div className="font-semibold text-[#0A0A0A]">Account manager</div>
                                    <div className="mt-1 text-gray-600 leading-[1.65]">
                                        Outreach, coordination, reporting, day-to-day execution.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </FadeUp>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                    {items.map((it, i) => (
                        <FadeUp key={i} delay={0.03 + (i % 6) * 0.03}>
                            <div
                                data-testid={`included-item-${i}`}
                                className="h-full rounded-2xl border border-black/[0.08] bg-white p-5 hover:border-black/20 transition-colors"
                            >
                                <div className="h-9 w-9 rounded-lg bg-[#FAFAFA] border border-black/[0.06] flex items-center justify-center">
                                    <it.icon className="h-4.5 w-4.5 text-[#0A0A0A]" strokeWidth={1.8} />
                                </div>
                                <p className="mt-4 text-[14px] font-semibold text-[#0A0A0A] leading-[1.65]">
                                    {it.label}
                                </p>
                            </div>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default WhatsIncluded;
